import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "@/lib/authContext";
import { useSessionUser } from "@/hooks/useSessionUser";

type ProtectedRouteProps = {
  children: ReactNode;
  requiredPermissions?: string[];
  anyOfPermissions?: string[];
};

export function ProtectedRoute({ children, requiredPermissions, anyOfPermissions }: ProtectedRouteProps) {
  const { isAuthenticated } = useAuth();
  const { hasPermission, hasAnyPermission } = useSessionUser();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredPermissions && requiredPermissions.length > 0) {
    const missing = requiredPermissions.some((permission) => !hasPermission(permission));
    if (missing) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  if (anyOfPermissions && anyOfPermissions.length > 0) {
    const allowed = hasAnyPermission(anyOfPermissions);
    if (!allowed) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <>{children}</>;
}

export default ProtectedRoute;
